import {Component, OnInit} from '@angular/core';
import {ReasonService} from "../../services/reason.service";
import {Reason} from "../../entities/reason";

@Component({
  selector: 'app-saved-reasons',
  standalone: true,
  imports: [],
  templateUrl: './saved-reasons.component.html',
  styleUrl: './saved-reasons.component.css'
})
export class SavedReasonsComponent implements OnInit {
  constructor(private reasonService: ReasonService) {  }

  reasons: Reason[] = [];

  ngOnInit(): void {
        this.reasonService.getSavedReasons().then(
          saved=>saved.forEach(e=>
            e.reason.forEach(r=>
              this.reasonService.getReason(r)
                .then(i=> {
                    this.reasonService.getTopic(i.topic).then(topic => {
                      i.topic = topic?.topicname ?? ""
                    })
                    this.reasons.push(i)
                  }
                )
            )
          )
        )
    }

  openReason(id: String) {
    this.reasonService.openReason(id)
  }
}
